<template>
  <div class="myscan-view">
    <van-nav-bar title="扫一扫" :fixed="true" left-text="返回" :border="false" left-arrow @click-left="backPage" />
    <!-- <camera class='scan-camera' mode="scanCode" binderror="cameraError" @scancode='myScanCode' frame-size='large'>
    </camera> -->
    <video ref="video" id="video" class="scan-camera" autoplay></video>
    <div class="aaa"></div>
    <div v-show="tipShow" class="tip">{{tipMsg}}</div>
  </div>
</template>

<script>
import { BrowserMultiFormatReader } from '@zxing/library'
import tokenVerify from '@/utils/lib/token-verify'; //token验证
import bus from '@/utils/lib/bus';
export default {
  data: () => ({
    loadingShow: false,
    codeReader: null,
    textContent: null,
    tipMsg: '正在尝试识别....',

    flag:false,//避免多次请求
    tipShow:false,
    imei:'',
    myTimer:null,//定时器
    goback:false,
  }),
  created() {
    if(this.$route.query.data){
      this.goback = this.$route.query.data
      console.log(this.goback,29)
    }
  },
  mounted() {
    this.codeReader = new BrowserMultiFormatReader()
    this.openScan()
  },
  beforeUnmount() {
    this.codeReader && this.codeReader.reset()
  },
  destroyed(){
    this.flag = true
    this.codeReader && this.codeReader.reset()
    if(this.myTimer!=null){
      clearTimeout(this.myTimer);
      this.myTimer = null
    }
  },
  methods: {
    /**
     * 返回上一级
     */
    backPage() {
        this.$router.back(-1);
    },
    myScanCode(str){
      if(this.goback){
        let num = str.indexOf("@")==-1?str.length:str.indexOf("@")
        this.imei=str.substring(0, num);
        this.$store.commit('set_changeImei', this.imei);
        this.backPage()
        return
      }
      if(this.flag) return
      if(this.myTimer!=null){
        clearTimeout(this.myTimer);
        this.myTimer = null
      }
      this.flag = true
      // let str = e.mp.detail.result
      let num = str.indexOf("@")==-1?str.length:str.indexOf("@")
      this.imei=str.substring(0, num);
      let data = {
        ver:1,
        method:'shiNiuAddDevice',
        imei:this.imei
      }
      this.$http.post(this.$api.userInfo.POST_APPLET,data).then(res => {
          if (res.code === 0) {
            this.flag = true
            tokenVerify(res.data.token)
            this.$router.push({ name: "location" });
          } else{
            this.$toast({
                message: res.msg,
                duration: 2000,
                icon: require('@/assets/images/safety-fence/wrong.png'),
            });
            this.myTimer = setTimeout(()=>{
              this.flag = false
            },3000)
          }
      })
      // 校验扫描结果，并处理
      // let res = e.mp.detail.result
    },
    async openScan() {
        const that = this
        // const codeReader = new ZXing.BrowserQRCodeReader()
        that.codeReader.getVideoInputDevices().then((videoInputDevices) => {
          that.tipShow = true
          that.tipMsg = '正在调用后置摄像头...'
          console.log('videoInputDevices', videoInputDevices);
          // 默认获取第一个摄像头设备id
          let firstDeviceId = videoInputDevices[0].deviceId;
          // 获取第一个摄像头设备的名称
          const videoInputDeviceslablestr = JSON.stringify(videoInputDevices[0].label);
          if (videoInputDevices.length > 1) {
            // 判断是否有后置摄像头
            that.tipMsg = videoInputDeviceslablestr
            // if (videoInputDeviceslablestr.indexOf('back') > -1) {
            //   firstDeviceId = videoInputDevices[1].deviceId;
            // } else {
            //   firstDeviceId = videoInputDevices[0].deviceId;
            // }
            firstDeviceId = videoInputDevices[1].deviceId;
          }
          that.codeReader && that.codeReader.reset() // 重置
          that.decodeFromInputVideoFunc(firstDeviceId)
        }).catch((err) => {
          that.tipShow = false
          console.error(err);
        });
      },
      decodeFromInputVideoFunc(firstDeviceId) {
        const that = this
        // that.codeReader.reset() // 重置
        that.textContent = null // 重置
        that.codeReader.decodeFromInputVideoDeviceContinuously(firstDeviceId, 'video', (result, err) => {
          that.tipMsg = '正在尝试识别...'
          // let nowContent = null
          that.textContent = null
          if (result) {
            console.log(result);
            that.tipMsg = result.text
            that.textContent = result.text;
            if (that.textContent) {
              that.tipShow = false
              this.myScanCode(that.textContent)
              // that.msgBoxFunc(that.textContent)
            }
          }
          if (err && !(err)) {
            that.tipMsg = '识别失败'
            setTimeout(() => {
              that.tipShow = false
            },2000)
            console.error(err);
          }
        });
      },
  },
};
</script>

<style lang="scss" scoped>
@keyframes move1{
    from{
      top: 200px;
    }
    to{
      top: 800px;
    }
  }
.myscan-view{
  background-color: #000000;
  width: 100%;
  height: 100vh;
  font-family: PingFangSC-Regular, PingFang SC;
}
.scan-camera{
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
}
// .scan-camera::after{
//   content: '';
//   width: 582px;
//   height: 86px;
//   background: linear-gradient(180deg, rgba(80, 204, 113, 0) 0%, rgba(80, 204, 113, 0.2) 63%, #50CC71 100%);
//   position: fixed;
//   top: 200px;
//   animation: move1 4s linear infinite;
// }
.aaa{
  width: 582px;
  height: 86px;
  background: linear-gradient(180deg, rgba(80, 204, 113, 0) 0%, rgba(80, 204, 113, 0.2) 63%, #50CC71 100%);
  position: fixed;
  left: 50%;
  margin-left: -291px;
  top: 200px;
  animation: move1 4s linear infinite;
}
.tip{
  position: relative;
  bottom: 50px;
  color: white;
  font-size: 16px;
}
</style>
